// 格式化工具

// 手机号脱敏：186****3040
export function maskPhone(phone: string): string {
  if (!phone || phone.length < 7) return phone;
  return `${phone.slice(0, 3)}****${phone.slice(-4)}`;
}

// 数字格式化：保留 2 位小数，避免 -0
export function fmtNum(v: number | null | undefined, digits = 2): string {
  if (v == null || Number.isNaN(v)) return "--";
  const n = Math.round(v * 10 ** digits) / 10 ** digits;
  return n === 0 ? "0.00" : n.toFixed(digits);
}

// 涨跌幅带符号：+1.23%
export function fmtPercent(v: number | null | undefined, digits = 2): string {
  if (v == null || Number.isNaN(v)) return "--";
  const n = v * 100;
  if (n === 0) return "0.00%";
  return `${n > 0 ? "+" : ""}${n.toFixed(digits)}%`;
}

// 成交量格式化：万 / 亿
export function fmtVolume(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "--";
  if (v >= 1e8) return `${(v / 1e8).toFixed(2)}亿`;
  if (v >= 1e4) return `${(v / 1e4).toFixed(2)}万`;
  return String(v);
}

// 涨跌色 class
export function percentClass(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v) || v === 0) return "flat";
  return v > 0 ? "up" : "down";
}

// 验证手机号（支持 +86 号段）
export function isValidPhone(phone: string): boolean {
  return /^1[3-9]\d{9}$/.test(phone);
}

// 验证密码：大小写字母 + 数字，8-26 位
export function isValidPassword(password: string): boolean {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,26}$/.test(password);
}

// 交易所跳转链接
export function exchangeUrl(exchange: string, code: string): string | null {
  if (exchange === "SH") {
    return `https://www.sse.com.cn/assortment/stock/list/info/company/index.shtml?COMPANY_CODE=${code}`;
  }
  if (exchange === "SZ") {
    return `https://www.szse.cn/market/trend/index.html?code=${code}`;
  }
  return null;
}
